import { z } from "zod";

export const externalSongSchema = z.object({
  isrc: z.string().nullable(),
  image: z.string().nullable(),
  title: z.string(),
  artist_names: z.array(z.string()).nullable(),
});
